<app-header></app-header>

<div class="min-h-screen flex items-center short:items-start justify-center px-4 sm:px-6 md:px-8 short:pt-24 short:pb-8 bg-cover bg-center"
    [ngStyle]="{ 'background-image': 'url(assets/images/employer-login.png)' }">

    <div class="bg-white p-4 sm:p-6 md:p-8 short:py-3 rounded-lg shadow-md w-full max-w-2xl">
        <div class="flex justify-start mb-4 sm:mb-6 short:mb-2 pb-2 short:pb-1 border-b-[1px] ">
            <img src="assets/images/logo-red.png" class="h-10 sm:h-12 md:h-14 short:h-10" />
        </div>

        <!-- Login Form -->
        <div>
            <h2 class="text-center text-lg sm:text-xl md:text-2xl font-medium text-gray-700 mb-2">
                {{ 'EMPLOYER.LOGIN.LOGIN' | translate }}
            </h2>
            <p class="text-center text-sm sm:text-base text-gray-500 mb-4 sm:mb-6 short:mb-2">
                {{ 'EMPLOYER.LOGIN.LOGIN_DESCRIPTION' | translate }}
            </p>

            <div class="flex justify-center">
                <div class="w-full max-w-md px-2 sm:px-0">
                    <div class="mb-3 sm:mb-4 short:mb-2">
                        <label class="block text-xs sm:text-sm text-gray-400 mb-2 sm:mb-4 short:mb-1">{{ 'EMPLOYER.LOGIN.LOGIN_EMAIL' | translate
                            }}</label>
                        <input class="w-full px-3 sm:px-4 py-2.5 sm:py-3 text-base border rounded-3xl focus:outline-none"
                            [(ngModel)]="policyOrEmail" placeholder="{{ 'EMPLOYER.LOGIN.LOGIN_EMAIL' | translate }}"
                            (input)="validatePolicyOrEmail()" tabindex="1" (keydown.enter)="isFormValid() && login()" />
                        <div *ngFor="let error of policyOrEmailErrors" class="text-red-500 text-xs sm:text-sm mt-1">
                            {{ error | translate }}
                        </div>
                    </div>

                    <div class="mb-4 sm:mb-6 short:mb-3">
                        <div class="flex flex-col sm:flex-row sm:justify-between mb-2 sm:mb-4 short:mb-1 gap-2">
                            <label class="block text-xs sm:text-sm text-gray-400">{{ 'EMPLOYER.LOGIN.LOGIN_PASSWORD' | translate
                                }}</label>
                            <a routerLink="/employer/account/password" class="text-[0.65rem] text-red-500 hover:underline min-h-[44px] inline-flex items-center">{{
                                'EMPLOYER.LOGIN.FORGOT_PASSWORD' | translate }}</a>
                        </div>
                        <app-password-input
                            [(ngModel)]="password"
                            [placeholder]="'EMPLOYER.LOGIN.LOGIN_PASSWORD' | translate"
                            [tabindex]="2"
                            (input)="validatePassword()"
                            (keydown.enter)="isFormValid() && login()">
                        </app-password-input>
                        <div *ngFor="let error of passwordErrors" class="text-red-500 text-xs sm:text-sm mt-1">
                            {{ error | translate }}
                        </div>
                    </div>

                    <!-- Login Error Message -->
                    <div *ngIf="loginError"
                        class="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 text-xs sm:text-sm rounded">
                        {{ loginError }}
                    </div>

                    <button (click)="login()" [disabled]="!isFormValid() || loading"
                        class="w-full rounded-3xl bg-white border-4 border-red-500 text-red-500 py-3 text-base sm:text-lg font-medium min-h-[48px]"
                        [ngClass]="{ 'opacity-50 cursor-default': !isFormValid() || loading, 'active:bg-red-500 active:text-white': isFormValid() && !loading }">
                        <span *ngIf="!loading">{{ 'EMPLOYER.LOGIN.LOGIN_BUTTON' | translate|uppercase }}</span>
                        <span *ngIf="loading">PLEASE WAIT...</span>
                    </button>

                    <div class="text-center mt-4 sm:mt-6 short:mt-2">
                        <span class="text-sm sm:text-base text-gray-500">Don't have an account? </span>
                        <a routerLink="/employer/account/signup" class="text-sm sm:text-base text-red-500 hover:underline min-h-[44px] inline-flex items-center">
                            Sign Up
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <app-card-footer></app-card-footer>
    </div>
</div>
